import React, { useRef } from 'react'
import { DarkModeIcon, LightModeIcon, PasswordIcon, UsernameIcon } from '../../components/iconSet/IconSet'
import { ThemeTypes } from '../../context/ContextTypes'

/* Import images */
import logoIcon from '../../images/icons/logo.png'
import { useNavigate } from 'react-router-dom'
import { API_REGISTER_USER_URL, APIRegisterUserTypes } from '../../services/APIAuthorizationService'
import { APICall, DATA_VALIDATION_ERROR, RECODE_ALREADY_EXIST } from '../../services/APIService'
import { useTheme } from '../../context/ThemeContext'

const RegisterPage = () => {
    const navigate = useNavigate()
    const {theme, setTheme} = useTheme()

    const usernameRef = useRef<HTMLInputElement | null>(null)
    const passwordRef = useRef<HTMLInputElement | null>(null)

    /* Handle login */
    const handleSignUpButtonClick = async (e: React.FormEvent) => {

        e.preventDefault()
        if(usernameRef.current && passwordRef.current)
        {
            const requestBody: APIRegisterUserTypes = {
                username: usernameRef.current.value,
                password: passwordRef.current.value,
                role: []
            }

            const response = await APICall(API_REGISTER_USER_URL, 'POST', requestBody)

            if (response.httpStatus === 'OK') {
                window.location.href = '/login'
            }
            else if (response.errorCode === DATA_VALIDATION_ERROR) {
                console.log('data validation error while registering: ', response.data)
            }
            else if (response.errorCode === RECODE_ALREADY_EXIST){
                console.log('user already exists')
            }
            else {
                console.log('something is wrong')
            }
        }
    }

    /* Handle forget password click */
    const handleForgetPasswordClick = () => {
        
    }

    /* Handle theme change button click */
    const handleThemeChangeClick = (type: ThemeTypes) => {
        setTheme(prevState => type)
    }

    return (
        <div className={`login-page-wrapper ${theme}`}>
            <div className={`login-container`}>
                <div className={`form-area`}>
                    <span className={`title`}>signup to dashboard</span>
                    <div className={`input-wrapper`}>
                        <i>
                            <UsernameIcon color='var(--color-main-white)' width='1.2rem' />
                        </i>
                        <input type="text" placeholder='Enter Username' ref={usernameRef} />
                    </div>
                    <div className={`input-wrapper`}>
                        <i>
                            <PasswordIcon color='var(--color-main-white)' width='1.2rem' />
                        </i>
                        <input type="password" placeholder='Enter Password' ref={passwordRef} />
                    </div>
                    <div className={`button-wrapper`}>
                        <button className={`button-full`} onClick={(e) => handleSignUpButtonClick(e)}>Signup</button>
                    </div>
                    <div className={`extra-wrapper`}>
                        <div className={`check-box-wrapper`}>
                            
                        </div>
                        <span onClick={() => window.location.href = '/login'}>already account available?</span>
                    </div>
                </div>
                <div className={`logo-area`}>
                    <img className={`logo-image`} src={logoIcon} alt="" />
                    <span onClick={(e) => handleForgetPasswordClick()}>tecxal systems</span>
                </div>

                {theme === 'dark' ? (
                    <div className={`theme-button-wrapper`} onClick={(e) => handleThemeChangeClick('light')}>
                        <LightModeIcon color='white' width='2rem' />
                    </div>
                ) : theme === 'light' ? (
                    <div className={`theme-button-wrapper`} onClick={(e) => handleThemeChangeClick('dark')}>
                        <DarkModeIcon color='white' width='1rem' />           
                    </div>
                ) : null}
                
            </div>
        </div>
    )
}

export default RegisterPage